import { memo } from "react";
import "./index.css";

function FloatingDoodle({
  source,
  className = "",
  duration = 3500,
  distance = 12,
  animate = true,
}) {
  const classes = ["floating-doodle", animate ? "floating-doodle-animated" : "", className]
    .filter(Boolean)
    .join(" ");

  return (
    <img
      src={source}
      alt=""
      aria-hidden="true"
      className={classes}
      style={{
        "--floating-doodle-duration": `${duration}ms`,
        "--floating-doodle-distance": `${distance}px`,
      }}
      draggable="false"
    />
  );
}

export default memo(FloatingDoodle);